var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { content: "Información de Contacto", "has-line": true }
      }),
      _c(
        "div",
        { staticClass: "contact-information-list mt-3" },
        [
          _vm._l(_vm.value, function(contact, idx) {
            return _c(
              "custom-callout",
              {
                key: idx,
                staticClass: "mb-2",
                attrs: {
                  "show-edition":
                    !_vm.disabled &&
                    _vm.editMode &&
                    _vm.editInfo.data != null &&
                    _vm.editInfo.index == idx
                },
                scopedSlots: _vm._u(
                  [
                    _vm.editMode && _vm.editInfo.index == idx
                      ? {
                          key: "edition",
                          fn: function() {
                            return [
                              _c("contact-information-add-edit", {
                                attrs: {
                                  "civil-statuses": _vm.civilStatuses,
                                  "disable-primary":
                                    _vm.value.length < 2 &&
                                    _vm.editInfo.data?.isPrimary
                                },
                                on: {
                                  "on-cancel": _vm.onContactCanceled,
                                  "on-saved": _vm.onContactSaved
                                },
                                model: {
                                  value: _vm.editInfo.data,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editInfo, "data", $$v)
                                  },
                                  expression: "editInfo.data"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                )
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-1 text-center align-middle mt-2" },
                    [
                      _c(
                        "div",
                        { staticClass: "dot text-center color-white" },
                        [
                          _c("i", {
                            staticClass: "fa fa-phone fa-flip-horizontal"
                          })
                        ]
                      )
                    ]
                  ),
                  _c("div", { staticClass: "col-sm cell" }, [
                    _c("div", { staticClass: "data" }, [
                      _c("span", [
                        _vm._v(
                          " Contacto " +
                            _vm._s(
                              contact.isPrimary ? "Primario" : "Secundario"
                            ) +
                            ": "
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(contact.nameFirst) +
                            " " +
                            _vm._s(contact.nameLastPaternal) +
                            " " +
                            _vm._s(contact.nameLastMaternal) +
                            " "
                        )
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm cell" }, [
                    _c("span", [_vm._v("Posición:")]),
                    _c("p", [_vm._v(_vm._s(contact.workPositionTitle))])
                  ]),
                  _c("div", { staticClass: "col-sm cell" }, [
                    _c("span", [_vm._v("Trabajo:")]),
                    _c("p", [
                      _vm._v(_vm._s(_vm._f("phone")(contact.telephoneWorkNo)))
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm cell" }, [
                    _c("span", [_vm._v("Celular:")]),
                    _c("p", [
                      _vm._v(_vm._s(_vm._f("phone")(contact.telephoneMobileNo)))
                    ])
                  ]),
                  !_vm.disabled && _vm.canPerformActions
                    ? _c(
                        "div",
                        { staticClass: "col-sm cell actions" },
                        [
                          _c("drop-down", {
                            attrs: {
                              "data-item": idx,
                              items: _vm.getAvailableActions(contact)
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            )
          }),
          _c("custom-callout", {
            staticClass: "mb-2",
            attrs: {
              "show-container": false,
              "show-edition": !_vm.disabled && _vm.createMode
            },
            scopedSlots: _vm._u([
              {
                key: "edition",
                fn: function() {
                  return [
                    _c("contact-information-add-edit", {
                      attrs: {
                        "civil-statuses": _vm.civilStatuses,
                        "disable-primary": _vm.value.length == 0
                      },
                      on: {
                        "on-cancel": _vm.onContactCanceled,
                        "on-saved": _vm.onContactSaved
                      },
                      model: {
                        value: _vm.editInfo.data,
                        callback: function($$v) {
                          _vm.$set(_vm.editInfo, "data", $$v)
                        },
                        expression: "editInfo.data"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          }),
          !_vm.disabled
            ? _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _vm.editInfo.data == null && _vm.canAddContact
                      ? _c("action-button", {
                          staticClass: "float-right",
                          attrs: {
                            i: "fas fa-plus",
                            text: "Añadir",
                            variant: "success"
                          },
                          on: { click: _vm.newContact }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }